// extracted by mini-css-extract-plugin
export var icon = "_6f-1";
export var subtext = "_6f-0";